import { useMutation } from '@apollo/client';
import { stagingOptions } from 'constants/apollo';
import { MergeOrdersToShipmentPayload } from "api/mutations/ShipmentMutation";
import { useEffect } from 'react';
import { toast } from 'react-toastify';
import { getColorFromTrackingNumber } from 'constants/map';

export const useMergeOrder = ({ clearUp = () => { }, setAllShipments, selectedShipments }) => {
    const [handleGqlMergeOrder, { data, loading, error }] =
        useMutation(MergeOrdersToShipmentPayload, { ...stagingOptions, fetchPolicy: "network-only" });
    useEffect(() => {
        if (data) {
            try {
                if (data?.mergeOrdersToShipment) {
                    const orderIDs = selectedShipments.map(shipment => shipment.id);
                    const ordersString = orderIDs.join(' ');
                    const shipmentID = data?.mergeOrdersToShipment?.shipments?.[0]?.id;
                    const trackingNo = data?.mergeOrdersToShipment?.shipments?.[0]?.trackingNo;
                    toast.success(`Orders ${ordersString} merged into shipment ${shipmentID}`);
                    let color = getColorFromTrackingNumber(trackingNo)
                    setAllShipments((prevState) => {
                        const updatedShipments = prevState.map((shipment) => ({
                            ...shipment,
                            shipment: orderIDs.includes(shipment.id) ? { ...shipment.shipment, id: shipmentID } : shipment.shipment,
                            color: orderIDs.includes(shipment.id) ? color : shipment.color
                        }));
                        return updatedShipments;
                    });
                } else {
                    toast.error(`Something went wrong while merging orders`);
                }
            } catch (error) {
                toast.error(`Something went wrong while merging orders`);
            }
        }
    }, [data])

    function handleMergeOrder(isPublish = false) {
        if (selectedShipments.length < 2) {
            toast.info('Select two or more orders to merge into a shipment');
            return;
        }
        const allSameMerchant = selectedShipments.every(
            shipment => shipment.merchant.id === selectedShipments[0].merchant.id
        );

        if (!allSameMerchant) {
            toast.error('Please select orders from the same merchant to merge.');
            return;
        }
        try {
            const trackingNos = selectedShipments.map(shipment => shipment.tracking_no);
            toast.info(isPublish ? 'Merging and publishing orders...' : 'Merging orders...');
            handleGqlMergeOrder({
                variables: {
                    input: {
                        trackingNos,
                        publish: isPublish
                    }
                }
            })
        } catch (error) {
            toast.error('Something went wrong while processing the request');
        }
    }

    return { handleMergeOrder }
}
